export default "__VITE_ASSET__Bzc_HEsN__"